import React, { useState } from 'react'
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Badge } from 'reactstrap'
import { Link } from "react-router-dom"
import DeleteModal from "components/Common/DeleteModal"
import { SuccessOk } from 'configs/statusCode'
import { toast } from 'react-toastify'
import { adminPrefix } from 'configs/routePrefix'
import { useSelector } from "react-redux"

const CardItem = (props) => {
    const { index, item, id, Service, name, status, updateHandler, setShouldGetData } = props
    const [deleteModal, setDeleteModal] = useState(false)
    const [dropdownOpen, setDropdownOpen] = useState(false)
    const [itemStatus, setItemStatus] = useState(status)
    const AuthData = useSelector(state => state.Auth)
    const isExist = (data) => (AuthData.permissions.includes(data) || AuthData.email === "admin@meras.com")
    const service = new Service


    const getRate = (rates) => {
        let result = 0
        rates.forEach(rate => {
            result += parseInt(rate.pivot.rate)
        })
        return rates.length ? `${ Number.isInteger(result / rates.length) ? result / rates.length :(result / rates.length).toFixed(2)} %` : "_"
    }
    const toggle = () => setDropdownOpen(prevState => !prevState)
    const handleCloseModal = (action, response) => {
        setDeleteModal(false)
        if (action === "delete") {
            setShouldGetData(true)
        }
    }
    const changeStatus = (e) => {
        const value = e.target.checked
        service.toggleStatus(id).then((res) => {
            if (res && res.status === SuccessOk) {
                toast.success("Status Changed Successfully")
                setItemStatus(value)
                toast.success(res.data.success)
                setTimeout(() => {
                    setShouldGetData(true)
                }, 1000)

            }
        })
    }

    return (
        <>
            <tr key={index}>
                <td className='font-size-14'>{id}</td>
                <td className='font-size-14' style={{fontWeight: 700 }}>
                    <Link to={`${adminPrefix}/Admin-developer/compound-list/${id}`} onClick={()=> localStorage.setItem('developer_id', id)}>
                        {name.en}
                    </Link>
                </td>
                <th className='font-size-14'>{item.compounds_num}</th>
                <th className='font-size-14'>{item.units_num}</th>
                <th className='font-size-14'>{item.areas?.map((area,areaIndex) => {
                    return (
                        <span key={areaIndex}>
                            <Badge className="bgBadge font-size-14 mt-0 m-1"  
                                style={{ background: "#50a5f1",marginTop:"0px !important" }}>
                                    {area?.name?.en}
                            </Badge>
                            {areaIndex === 3 && <br />}
                            {areaIndex === 7 && <br />}
                         </span>
                    )
                })}</th>
                <td className='font-size-13 py-0'>
                    <form>
                        <div className='form-check form-switch form-switch-md mb-1'>
                            <input
                                name='status'
                                checked={itemStatus}
                                type='checkbox'
                                className='form-check-input'
                                id='has_status'
                                onChange={changeStatus}
                                disabled={isExist("developers.edit") ? false:true}
                            />
                        </div>
                    </form>
                </td>
                <td className="removebtnhover">
                    <Dropdown className="dropdownWidth" color="light" isOpen={dropdownOpen} toggle={toggle}>
                        <DropdownToggle caret>
                            <i className="fa fa-ellipsis-v text-dark fa-lg"></i>
                        </DropdownToggle>
                        <DropdownMenu>
                            {/* <DropdownItem tag={Link} to={`${adminPrefix}/developer-profile/${item.id}`}>View</DropdownItem> */}
                            {isExist("developers.edit")
                                ?
                                <DropdownItem onClick={updateHandler}>Edit</DropdownItem>
                                : null}
                            {isExist("developers.delete")
                                ?
                                <DropdownItem className="text-danger"
                                    onClick={() => setDeleteModal(!deleteModal)}
                                >Remove Developer</DropdownItem>
                                : null}
                        </DropdownMenu>
                    </Dropdown>
                </td>
            </tr>
            <DeleteModal
                open={deleteModal}
                titleMsg={name.en}
                deletedItem={item}
                modelService={service}
                onCloseModal={(action) => handleCloseModal(action)}
            />
        </>

    )
}

export default CardItem